import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	moveButtonLabel: {
		id: 'admin-pages-priorities.priorities-table.actions.reorder.move-button-label',
		defaultMessage: 'Move priority {priorityName}',
		description: 'Label for icon button to show dropdown menu for moving priorities',
	},
	moveUp: {
		id: 'admin-pages-priorities.priorities-table.actions.reorder.move-up',
		defaultMessage: 'Move up',
		description: 'Action item in dropdown menu to reorder a priority up by one level',
	},
	moveDown: {
		id: 'admin-pages-priorities.priorities-table.actions.reorder.move-down',
		defaultMessage: 'Move down',
		description: 'Action item in dropdown menu to reorder a priority down by one level',
	},
	selectPosition: {
		id: 'admin-pages-priorities.priorities-table.actions.reorder.select-position',
		defaultMessage: 'Select position',
		description: 'Action item in dropdown menu to change the position of a priority',
	},
});
